import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import Portfolio from "./components/Portfolio";
import SocialShowcase from "./components/SocialShowcase";
import Stats from "./components/Stats";
import Testimonials from "./components/Testimonials";
import Process from "./components/Process";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import ChatbotWidget from "../components/chatbot/ChatbotWidget";

export default function MarketingPage() {
  return (
    <div className="marketing-site relative min-h-screen overflow-x-hidden bg-ink text-white antialiased">
      <div className="grain-layer" aria-hidden />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Services />
        <Portfolio />
        <SocialShowcase />
        <Stats />
        <Testimonials />
        <Process />
        <Contact />
      </main>
      <Footer />
      <ChatbotWidget />
    </div>
  );
}
